// // in this the vedio is not auto play while coming in the focus point
// import React, { useRef, useState, useEffect } from "react";
// import "./ourWork.css";
// import CameraMan from "./image/cameraManFrame.png";
// import CameraManVedio from "./image/cameraManVedio.mp4";
// import { PiGreaterThanBold, PiLessThanBold } from "react-icons/pi";
// import webPixwala from "./image/webPixwala.mp4";
// import vedioPixwala from "./image/vedioPixwala.mp4";
// import shootPixwala from "./image/shootPixwala.mp4";
// import graphicPixwala from "./image/graphicPixwala.mp4";

// const OurWork = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [scrollPosition, setScrollPosition] = useState(0);
//   const [isScrollable, setIsScrollable] = useState(false);
//   const containerRef = useRef(null);

//   const handleMouseEnter = (index) => setHoveredCard(index);
//   const handleMouseLeave = () => setHoveredCard(null);

//   const cardsData = [
//     {
//       id: 1,
//       image: CameraMan,
//       text1: "Capture",
//       text2: "Events",
//       video: shootPixwala,
//     },
//     {
//       id: 2,
//       image: CameraMan,
//       text1: "Innovative",
//       text2: "Designs",
//       video: graphicPixwala,
//     },
//     {
//       id: 3,
//       image: CameraMan,
//       text1: "Video",
//       text2: "Transformation",
//       video: vedioPixwala,
//     },
//     {
//       id: 4,
//       image: CameraMan,
//       text1: "Build",
//       text2: "Websites",
//       video: webPixwala,
//     },
//   ];
//   useEffect(() => {
//     const container = containerRef.current;
//     if (container) {
//       setIsScrollable(container.scrollWidth > container.clientWidth);
//       setScrollPosition(container.scrollLeft);
//     }
//   }, []); // Check on mount

//   const handleScroll = () => {
//     const container = containerRef.current;
//     if (container) {
//       setScrollPosition(container.scrollLeft);
//     }
//   };

//   const scrollLeft = () => {
//     containerRef.current.scrollBy({ left: -300, behavior: "smooth" });
//   };

//   const scrollRight = () => {
//     containerRef.current.scrollBy({ left: 300, behavior: "smooth" });
//   };

//   const isLeftActive = scrollPosition > 0;
//   {
//     /*
// scrollPosition is the number of pixels the container has been scrolled horizontally.
// If scrollPosition is greater than 0, it means the user has already scrolled to the right, and there's space to scroll left, so the left button should be active.
// If scrollPosition is 0 (i.e., at the far-left edge), it means there's no room to scroll left, so the left button should be inactive.
//  */
//   }
//   const isRightActive =
//     containerRef.current &&
//     Math.ceil(scrollPosition) <
//       Math.ceil(
//         containerRef.current.scrollWidth - containerRef.current.clientWidth
//       );
//   {
//     /*scrollPosition is the number of pixels the container has been scrolled horizontally.
// containerRef.current.scrollWidth is the total width of the scrollable content inside the container (including any overflow content that is hidden).
// containerRef.current.clientWidth is the visible width of the container (i.e., how much of the scrollable content is visible at any moment).
// scrollWidth - clientWidth gives the total width of the hidden (non-visible) content.
// If scrollPosition is less than scrollWidth - clientWidth, it means there is still content to the right of the container (i.e., the user hasn't reached the end of the scrollable content). Therefore, the right button should be active.
// If scrollPosition is equal to or greater than scrollWidth - clientWidth, it means the user is at the extreme right, and the right button should be inactive. */
//   }
//   const isAtEnd =
//     containerRef.current &&
//     Math.round(scrollPosition) >=
//       Math.round(
//         containerRef.current.scrollWidth - containerRef.current.clientWidth
//       );
//   {
//     /* Math.round(scrollPosition) rounds the scroll position to the nearest integer to avoid issues with floating-point precision.
// Math.round(scrollWidth - clientWidth) calculates the exact point at which the user has reached the right edge of the content.
// If scrollPosition is greater than or equal to scrollWidth - clientWidth, the user is at the far right, so the isAtEnd variable becomes true. */
//   }

//   return (
//     <div className="our-work-content" id="our-work">
//       <h1 className="heading-our-work">
//         <span className="heading1-our-work">TRANSFORMING</span>
//         <span className="heading2-our-work">PIXELS TO POSSIBILITIES</span>
//       </h1>

//       <div
//         className="card-container"
//         ref={containerRef}
//         onScroll={handleScroll}
//       >
//         {cardsData.map((card, index) => (
//           <div
//             key={card.id}
//             className="card"
//             onMouseEnter={() => handleMouseEnter(index)}
//             onMouseLeave={handleMouseLeave}
//             style={{
//               position: "relative", // Ensure z-index works by setting position
//               zIndex: hoveredCard === index ? 10 : 1, // Higher z-index for hovered card
//             }}
//           >
//             {hoveredCard === index ? (
//               <div className="card-inner-2">
//                 <video
//                   src={card.video}
//                   className="card-video"
//                   autoPlay
//                   loop
//                   muted
//                 />
//               </div>
//             ) : (
//               <div className="card-inner-1">
//                 <img
//                   src={card.image}
//                   alt={`Card ${card.id}`}
//                   className="card-image"
//                 />
//                 <div className="card-text">
//                   <div className="card-text-1">{card.text1}</div>
//                   <div className="card-text-2">{card.text2}</div>
//                 </div>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>

//       {isScrollable && (
//         <div className="arrows-ourWork">
//           {/* Left Button */}
//           <button
//             className={`arrow-btn-ourWork ${
//               isLeftActive || isAtEnd ? "active" : "inactive"
//             }`}
//             onClick={scrollLeft}
//             disabled={!isLeftActive && !isAtEnd}
//           >
//             <PiLessThanBold />
//             {/* <img src={LeftArrow} /> */}
//             {/* &lt; */}
//           </button>

//           {/* Right Button */}
//           <button
//             className={`arrow-btn-ourWork ${
//               isRightActive ? "active" : "inactive"
//             }`}
//             onClick={scrollRight}
//             disabled={!isRightActive}
//           >
//             <PiGreaterThanBold />
//             {/* <img src={RightArrow} /> */}
//             {/* &gt; */}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OurWork;

// in the vedio is auot play but on the click
import React, { useRef, useState, useEffect } from "react";
import "./ourWork.css";
import CameraMan from "./image/cameraManFrame.png";
import { PiGreaterThanBold, PiLessThanBold } from "react-icons/pi";
import webPixwala from "./image/webPixwala.mp4";
import vedioPixwala from "./image/vedioPixwala.mp4";
import shootPixwala from "./image/shootPixwala.mp4";
import graphicPixwala from "./image/graphicPixwala.mp4";
import webPhoto from "./image/webPhoto.webp";
import vedioPhoto from "./image/vedioPhoto.webp";
import shootPhoto from "./image/shootPhoto.webp";
import graphicPhoto from "./image/graphicPhoto.webp";

const OurWork = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef(null);
  const videoRefs = useRef([]);

  const handleMouseEnter = (index) => {
    setHoveredCard(index);
    if (window.innerWidth > 768) {
      const videoEl = videoRefs.current[index]?.querySelector("video");
      if (videoEl) {
        videoEl.currentTime = 0;
        videoEl.play();
      }
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) {
      const videoEl = videoRefs.current[hoveredCard]?.querySelector("video");
      if (videoEl) {
        // videoEl.pause();
      }
      setHoveredCard(null);
    }
  };

  const cardsData = [
    {
      id: 1,
      image: shootPhoto,
      text1: "Capture",
      text2: "Events",
      video: shootPixwala,
    },
    {
      id: 2,
      image: graphicPhoto,
      text1: "Innovative",
      text2: "Designs",
      video: graphicPixwala,
    },
    {
      id: 3,
      image: vedioPhoto,
      text1: "Video",
      text2: "Transformation",
      video: vedioPixwala,
    },
    // {
    //   id: 4,
    //   image: webPhoto,
    //   text1: "Build",
    //   text2: "Websites",
    //   video: webPixwala,
    // },
  ];

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      setIsScrollable(container.scrollWidth > container.clientWidth);
      setScrollPosition(container.scrollLeft);
    }
  }, []);

  const handleScroll = () => {
    const container = containerRef.current;
    if (container) {
      setScrollPosition(container.scrollLeft);
    }
  };

  const scrollLeft = () =>
    containerRef.current.scrollBy({ left: -300, behavior: "smooth" });
  const scrollRight = () =>
    containerRef.current.scrollBy({ left: 300, behavior: "smooth" });

  const isLeftActive = scrollPosition > 0;
  const isRightActive =
    containerRef.current &&
    Math.ceil(scrollPosition) <
      Math.ceil(
        containerRef.current.scrollWidth - containerRef.current.clientWidth
      );
  const isAtEnd =
    containerRef.current &&
    Math.round(scrollPosition) >=
      Math.round(
        containerRef.current.scrollWidth - containerRef.current.clientWidth
      );

  useEffect(() => {
    if (window.innerWidth > 768) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video");
          if (video) {
            if (entry.isIntersecting) {
              // video.play().catch(() => {});
              video
                .play()
                .catch((err) => console.warn("Autoplay blocked:", err));
            } else {
              // video.pause();
            }
          }
        });
      },
      { threshold: 0.5, root: containerRef.current }
    );

    videoRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      videoRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div className="our-work-content" id="our-work">
      <h1 className="heading-our-work">
        <span className="heading1-our-work">TRANSFORMING</span>
        <span className="heading2-our-work">PIXELS TO POSSIBILITIES</span>
      </h1>

      <div
        className="card-container"
        ref={containerRef}
        onScroll={handleScroll}
      >
        {cardsData.map((card, index) => (
          <div
            key={card.id}
            className="card"
            ref={(el) => (videoRefs.current[index] = el)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            style={{
              position: "relative",
              zIndex: hoveredCard === index ? 10 : 1,
            }}
          >
            <div
              className="card-inner-1"
              style={{ opacity: hoveredCard === index ? 0 : 1 }}
            >
              <img
                src={card.image}
                alt={`Card ${card.id}`}
                className="card-image"
              />
              <div className="card-text-overlay">
                <div className="card-text">
                  <div className="card-text-1">{card.text1}</div>
                  <div className="card-text-2">{card.text2}</div>
                </div>
              </div>

              {/* <div className="card-text">
                <div className="card-text-1">{card.text1}</div>
                <div className="card-text-2">{card.text2}</div>
              </div> */}
            </div>
            <div
              className="card-inner-2"
              style={{ opacity: hoveredCard === index ? 1 : 0 }}
            >
              <video
                src={card.video}
                className="card-video"
                loop
                muted
                playsInline
                preload="auto"
                ref={(el) => {
                  // Attach video ref directly for autoplay (for observer)
                  if (el && window.innerWidth <= 768) {
                    el.muted = true;
                    el.playsInline = true;
                  }
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {isScrollable && (
        <div className="arrows-ourWork">
          <button
            className={`arrow-btn-ourWork ${
              isLeftActive || isAtEnd ? "active" : "inactive"
            }`}
            onClick={scrollLeft}
            disabled={!isLeftActive && !isAtEnd}
          >
            <PiLessThanBold />
          </button>

          <button
            className={`arrow-btn-ourWork ${
              isRightActive ? "active" : "inactive"
            }`}
            onClick={scrollRight}
            disabled={!isRightActive}
          >
            <PiGreaterThanBold />
          </button>
        </div>
      )}
    </div>
  );
};

export default OurWork;
